<template>
  <div style="padding:20px;">
    <el-row :gutter="20">
      <el-row style="margin-bottom: 10px;">
        <el-button style="padding: 0; margin: 20px" type="text" icon="el-icon-back" @click="backPrePage()">返回
        </el-button>
        <el-button type="primary" size="mini" @click="getList()">查询</el-button>
        <el-button
          type="primary"
          size="mini"
          @click="
            search.chooseOrgVisible = true;
            searchData();
          "
          >增加</el-button
        >
      </el-row>

      <el-table :data="listData" style="width: 100%" border size="mini" v-loading="listLoading">
        <el-table-column prop="product_id" label="商品ID" width="90"></el-table-column>
        <el-table-column prop="title" label="商品标题"></el-table-column>
        <el-table-column label="商品图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 66px; " alt=""/>
          </template>
        </el-table-column>

        <el-table-column label="排序" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="updateSort(row.id)">
              <div>{{ row.sort }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.status == 1" style="color: #67c23a"><i class="el-icon-circle-check"></i> 已发布</span>
              <span v-else style="color: #909399"><i class="el-icon-circle-close"></i> 未发布</span>
              <el-button type="text" size="small" style="margin-left: 5px"
                         @click=" row.status == 1 ? updateOnline(row.id, 'offline') : updateOnline(row.id, 'online')">
                {{ row.status == 1 ? "下架" : "发布" }}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="danger" size="small" @click="deleteInfo(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top:10px">
        <el-pagination background @current-change="getList" :current-page.sync="query.page"
                       :page-size="query.limit"
                       layout="total, prev, pager, next, jumper" :total="listTotal">
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
        title="选择商品"
        :visible.sync="search.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="addEditFormOnClose"
        width="75%"
      >
        <el-form :inline="true" :model="search.query">
          <!-- 模糊查询 -->
          <el-form-item>
            <el-input
              size="mini"
              v-model="search.query.search"
              placeholder="请输入标题"
              clearable
              @blur="searchData()"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="searchData()">
              查询
            </el-button>
          </el-form-item>
        </el-form>

        <!--列表-->
        <el-table
          ref="multipleTable"
          border
          :data="search.result.data"
          highlight-current-row
          v-loading="search.listLoading1"
          style="..."
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="id"
            label="ID"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="title"
            label="标题"
            align="center"
          ></el-table-column>
          <el-table-column label="图片" align="center">
            <template slot-scope="{ row }">
              <img :src="row.img_url" style="width: 40px;" alt="" />
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="{ row }">
              <el-button
                type="primary"
                size="mini"
                @click="selectProduct(row)"
              >
                确定
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px">
          <el-button type="primary" :disabled="multipleSelection.length == 0" size="mini" @click="saveSelection()">确定</el-button>
        </div>
        <el-pagination
          background
          @current-change="searchData"
          :current-page.sync="search.query.page"
          :page-size="search.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="search.result.total"
        >
        </el-pagination>
      </el-dialog>

  </div>
</template>

<script>

import {
  collectionProductList,updateProductRelationSort,updateProductRelationOnline,deleteProductRelationInfo, updateProductRelationInfo
} from "@/api/productCollection";

import {
  screenProductList,
} from "@/api/coupon";

export default {
  data: function () {
    return {
      bannerTargetList: [],
      listData: [],
      listLoading: false,
      listTotal: 0,
      query: {
        limit: 20,
        page: 1
      },
      id:0,
      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          type: 1,
          target_type: 0,
          search: "",
          page: 1,
          limit: 5,
        },
        result: {
          total: 0,
          data: [],
        },
      },
      multipleSelection: []
    }
  },
  created: function () {
    this.id = this.$route.query.id;
    this.query.id = this.id;
    this.getList();
  },
  methods: {
    handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.query.search = "";
      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      screenProductList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    saveSelection() {
      var productIds = [];
      this.$refs.multipleTable.selection.forEach(row => {
        productIds.push(row.id);
      });
      updateProductRelationInfo({
        target_id: productIds.join(','),
        id: this.id,
      }).then(res => {
        if (res.code == 1) {
          this.$message.success(res.message);
          this.addEditFormOnClose();
          this.getList();
        }
      });
    },
    selectProduct(row) {
      this.$refs.multipleTable.selection.push(row);
      this.saveSelection();
    },

    filterBannerTarget(target) {
      return this.bannerTargetList[target];
    },
    getList() {
      this.listLoading = true;
      collectionProductList(this.query).then(response => {
        this.listData = response.data.list
        this.listTotal = response.data.total
        this.listLoading = false;
      });
    },
    deleteInfo(id) {
      this.$confirm('此操作将删除商品信息，是否确认操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        deleteProductRelationInfo({id}).then(response => {
          this.listLoading = false;
          if (response.code == 1) {
            this.getList();
            this.$message({
              showClose: true,
              duration: 2000,
              message: '删除成功',
              type: 'success'
            });
          }
        });
      }).catch(() => {

      });
    },
    updateSort(id) {
      this.$prompt("请输入排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputErrorMessage: "格式不正确",
      })
          .then(({value}) => {
            updateProductRelationSort({
              id: id,
              sort: value,
            }).then((response) => {
              if (response.status == 2000) {
                this.getList();
                this.$message({
                  showClose: true,
                  message: "设置成功",
                  type: "success",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            });
          })
          .catch(() => {
          });
    },
    gotoInfo(id) {
      this.$router.push({
        path: "/mall/collection/productInfo",
        query: {
          id: id,
          collection_id: this.id,
          admin_id: this.$route.query.admin_id,
          admin_name: this.$route.query.admin_name
        }
      });
    },
    updateOnline(id, type) {
      this.listLoading = true;
      updateProductRelationOnline({id, type}).then(response => {
        this.listLoading = false;
        if (response.code == 1) {
          this.getList();
          this.$message({
            showClose: true,
            duration: 2000,
            message: '修改成功',
            type: 'success'
          });
        }
      });
    },
    backPrePage() {
      this.$router.go(-1);
    }
  },
}
</script>
<style>
.el-button {
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>